

import Vue from 'vue'
import ExecutedQuantityTransformer from '@/transformers/purchase/executedQuantity'
import errorHandler from '@/utils/errorHandler'

export default (affectedId, opts = {}) => {
  const { fetchPrices } = opts
  const url = `purchase/real_executed_quantity/${affectedId}/`
  return errorHandler(Vue.$http.get(url), { separator: "\n"})
    .then(response => {
      const data = ExecutedQuantityTransformer.fetchCollection(response.data)
      return data
    })
    .catch(error => {
    	const response = error.response
    	if (response && response.status !== 404) {
    		throw error
    	} 
    })
}



// WEBPACK FOOTER //
// ./src/services/purchase/fetchRealQuantities.js